<template>
  <TermsandConditions />
  <FileReport />
</template>

<script setup lang="ts">
import TermsandConditions from "@/components/TermsandConditions.vue";
import FileReport from "@/components/FileReport.vue";
</script>
